import {WBIcon} from '@wandb/ui';
import {
  DragHandle as DragHandleComp,
  DragSource,
} from '@wandb/weave/common/containers/DragDropContainer';
import * as globals from '@wandb/weave/common/css/globals.styles';
import {Link} from '@wandb/weave/common/util/links';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import iconDelete from '../../assets/ic-delete.svg';
import iconDeleteLight from '../../assets/ic-delete-light.svg';
import iconDeleteRed from '../../assets/ic-delete-red.svg';
import iconLink from '../../assets/ic-link-sienna.svg';
import {UnstyledButton} from '../../components/UnstyledButton';

const BREAKPOINT_ONE_COL_PX = 1100;

export const Grid = styled.div`
  display: grid;
  grid-gap: calc(${globals.spu} * 3.5);

  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  @media (max-width: ${BREAKPOINT_ONE_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Card = styled(Link)`
  &:nth-child(odd) {
    grid-column: 1 / span 1;
  }
  &:nth-child(even) {
    grid-column: 2 / span 1;
  }

  @media (max-width: ${BREAKPOINT_ONE_COL_PX}px) {
    &:nth-child(1n) {
      grid-column: 1 / span 1;
    }
  }
`;

export const CardLinkIconContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: ${globals.SIENNA_LIGHT_TRANSPARENT_30};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardLinkIcon = styled.img.attrs({src: iconLink})``;

export const CardText = styled.div`
  position: relative;
`;

const clampStyles = css`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  font-size: calc(${globals.fontSizeStandard} * 1.25);
  color: ${globals.MOON_950};
  ${clampStyles}
`;

export const CardURL = styled.div`
  font-size: calc(${globals.fontSizeStandard} * 0.875);
  color: ${globals.MOON_600};
  margin-top: 2px;
  ${clampStyles}
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
`;

const actionButtonStyles = css`
  width: 20px;
  height: 20px;
`;

export const DeleteIconLight = styled.img.attrs({src: iconDeleteLight})``;
export const DeleteIconGray = styled.img.attrs({src: iconDelete})``;
export const DeleteIconRed = styled.img.attrs({src: iconDeleteRed})``;

export const DeleteButton = styled(UnstyledButton)`
  ${actionButtonStyles}
  margin-right: 6px;

  ${DeleteIconGray}, ${DeleteIconRed} {
    display: none;
  }
  ${DeleteIconLight} {
    display: block;
  }
  &:hover {
    ${DeleteIconLight}, ${DeleteIconGray} {
      display: none !important;
    }
    ${DeleteIconRed} {
      display: block !important;
    }
  }
`;

export const DragHandle = styled(DragHandleComp)`
  width: 28px;
  height: 28px;
`;

export const DragHandleIcon = styled(WBIcon).attrs({name: 'vertical-handle'})`
  font-size: calc(${globals.fontSizeStandard} * 1.75);
  border-radius: 50%;
  color: ${globals.gray300};
  user-select: none;
  cursor: grab;
  &&&:hover {
    background: ${globals.gray100};
    color: ${globals.black};
  }
  &:active {
    cursor: grabbing;
  }
`;

export const CardContent = styled(DragSource)`
  display: grid;
  grid-template-columns: 50px minmax(0, 1fr) 54px;
  grid-gap: 20px;
  background: ${globals.WHITE};
  position: relative;

  color: ${globals.TEXT_PRIMARY_COLOR};
  &:hover {
    color: ${globals.TEXT_PRIMARY_COLOR};
  }

  border: 1px solid ${globals.MOON_200};
  &:hover {
    border-color: ${globals.TEAL_450};
  }
  border-radius: 8px;

  padding: 19px 15px;

  &:hover ${DragHandleIcon} {
    color: ${globals.MOON_600};
  }
  &:hover ${DeleteIconLight}, &:hover ${DeleteIconRed} {
    display: none;
  }
  &:hover ${DeleteIconGray} {
    display: block;
  }
  transition: border-color 0.3s;
`;
